import React from "react";

const HideEyeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="hide_eye_icon"
      data-name="hide eye"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99913 15.8334C10.7875 15.8334 11.5075 15.7476 12.1641 15.5992L10.7 14.1351C10.4725 14.1526 10.2416 14.1667 9.99913 14.1667C5.53996 14.1667 3.81246 10.9617 3.39413 10.0001C3.70825 9.29906 4.1325 8.65284 4.65079 8.08589L3.48579 6.92089C2.20413 8.31006 1.71829 9.70922 1.70913 9.73672C1.65164 9.90786 1.65164 10.0931 1.70913 10.2642C1.72663 10.3192 3.63829 15.8334 9.99913 15.8334ZM9.99913 4.16672C8.4683 4.16672 7.21079 4.49672 6.16246 4.98422L3.08829 1.91089L1.90996 3.08922L16.91 18.0892L18.0883 16.9109L15.3225 14.1451C17.5008 12.5192 18.2783 10.2992 18.29 10.2642C18.3474 10.0931 18.3474 9.90786 18.29 9.73672C18.2716 9.68089 16.36 4.16672 9.99913 4.16672ZM14.1425 12.9651L12.2425 11.0651C12.4008 10.7401 12.4991 10.3826 12.4991 10.0001C12.4991 8.63256 11.3666 7.50006 9.99913 7.50006C9.61663 7.50006 9.25913 7.59839 8.93496 7.75756L7.42829 6.25089C8.25539 5.96707 9.12472 5.82589 9.99913 5.83339C14.4583 5.83339 16.1858 9.03839 16.6041 10.0001C16.3525 10.5767 15.6325 11.9517 14.1425 12.9651Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default HideEyeIcon;
